import { useContext } from 'react';
import { Context, CustomValidationContext } from 'form/components/CustomValidation/CustomValidation';
import { getIn } from 'formik';
import { useFormContext } from 'react-hook-form';

export const useCustomValidation = (): [Context, (name: string) => boolean] => {
  const {
    formState: { touchedFields, errors },
  } = useFormContext<any>();

  const context = useContext(CustomValidationContext);

  const { errors: customErrors, onlyTouched } = context;

  const shouldShowError = (name: string) => {
    const hasCustomError = Object.keys(customErrors).includes(name);
    const hasFormErrors = !!getIn(errors, name);

    return !hasFormErrors && hasCustomError && (!onlyTouched || (onlyTouched && getIn(touchedFields, name)));
  };

  return [context, shouldShowError];
};

export default useCustomValidation;
